<template>
  <b-modal
    v-model="show"
    centered
    hide-header
    hide-footer
    id="responsive-modal"
    :size="size"
    :value="show"
    @change="onchange"
  >
    <div
      class="draggable-line d-flex justify-content-center d-lg-none mb-3"
      @click="close"
      role="button"
    />
    <div class="overflow-y-scroll fit-scroll-content pt-lg-3 px-lg-5 pb-5">
      <div v-if="title" class="d-flex justify-content-between gap-5 mb-7">
        <div>
          <h3>{{ title }}</h3>
          <a
            v-if="link"
            :href="link"
            target="_blank"
            class="d-flex align-items-center gap-3 text-primary-600 pt-2"
          >
            <h4>
              {{ description }}
            </h4>
            <bp-icon icon="fa-regular fa-arrow-up-right-from-square" />
          </a>
          <h4 class="text-neutral-300" v-else-if="description">
            {{ description }}
          </h4>
        </div>
        <button class="btn close-button" @click="close">
          <i class="fa fa-close" />
        </button>
      </div>
      <slot />
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      show: this.value
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    }
  },
  watch: {
    value(val) {
      this.show = val;
    }
  },
  methods: {
    close() {
      this.show = false;
      this.$emit("input", false);
    },
    onchange(v) {
      this.show = v;
      this.$emit("input", v);
    }
  }
};
</script>
<style lang="scss" scoped>
.fit-scroll-content {
  overflow-x: hidden;
  max-height: 700px;
  @media screen and (max-width: 991px) {
    max-height: 600px;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  ::v-deep .modal-dialog {
    max-width: 100%;
  }
}

.close-button {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  font-size: 14px;
  color: rgba(42, 42, 42, 1);
  background-color: rgba(215, 215, 215, 0.48);
  border-radius: 20px;
  transition: 0.1s background-color;
  &:hover {
    background-color: rgba(215, 215, 215, 1);
  }
}
</style>
